module.exports = __webpack_public_path__ + "static/media/extreme_exercise.d7fd43cb.gif";